export default "__VITE_ASSET__5fb9daee__"